import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import { EmployeeCollaborationTask } from '~/data/collaboration';
import { WorklistFormData } from '~/scenes/PeopleModule/components/Tabs/CollaborationTab/WorklistTable/EditWorklistDialog/data';

export const useWorklistValidation = () => {
  const { t } = useTranslation();

  const errorMessages = useMemo(() => {
    return {
      requiredField: t('fieldIsRequired'),
    };
  }, [t]);

  const validationSchema = useMemo(() => {
    const { requiredField } = errorMessages;

    return yup.object().shape<WorklistFormData>({
      worklistId: yup.string().required(requiredField),
      templateId: yup.number(),
      startDate: yup.date(),
      dueDate: yup.date().required(requiredField),
      isLocked: yup.boolean(),
      status: yup.string(),
      employeeId: yup.number().required(requiredField),
      language: yup.string(),
      tasks: yup.array<EmployeeCollaborationTask>().required(requiredField),
    });
  }, [errorMessages]);

  return {
    validationSchema,
  };
};
